import {
  normalizeRange,
  type CellPos,
  type CellRange,
  type NormalizedRange,
} from '@/components/data-table/grid-selection'

/**
 * Seçim görünümü satırları yeniden çizdirmez (`TableRows` memo'lu, yüzlerce hücre): hücrelere
 * `data-sel*` öznitelikleri doğrudan yazılır, görünümü `index.css` (`td[data-sel]`) verir.
 * Hücreler `data-row`/`data-col` (görünen dizin) taşır.
 */
export const CELL_SELECTOR = 'td[data-row][data-col]'

const MARKS = [
  'data-sel',
  'data-sel-t',
  'data-sel-r',
  'data-sel-b',
  'data-sel-l',
  'data-sel-focus',
] as const

const toggle = (cell: Element, name: (typeof MARKS)[number], on: boolean) => {
  if (on) cell.setAttribute(name, '')
  else cell.removeAttribute(name)
}

/** `root` altındaki hücrelerin seçim işaretlerini `range`e göre yeniden yazar (`null`: temizle). */
export function applySelectionMarks(root: ParentNode, range: CellRange | null) {
  const area: NormalizedRange | null = range && normalizeRange(range)
  for (const cell of root.querySelectorAll<HTMLElement>(CELL_SELECTOR)) {
    const row = Number(cell.dataset.row)
    const col = Number(cell.dataset.col)
    const inside =
      area !== null &&
      row >= area.top &&
      row <= area.bottom &&
      col >= area.left &&
      col <= area.right
    if (!inside) {
      if (cell.hasAttribute('data-sel')) for (const mark of MARKS) cell.removeAttribute(mark)
      continue
    }
    toggle(cell, 'data-sel', true)
    toggle(cell, 'data-sel-t', row === area.top)
    toggle(cell, 'data-sel-b', row === area.bottom)
    toggle(cell, 'data-sel-l', col === area.left)
    toggle(cell, 'data-sel-r', col === area.right)
    toggle(cell, 'data-sel-focus', row === range!.focus.row && col === range!.focus.col)
  }
}

/** Olayın hedefinden hücre konumu; hücre dışıysa `null`. */
export function cellPosOf(target: EventTarget | null): CellPos | null {
  const cell = target instanceof Element ? target.closest<HTMLElement>(CELL_SELECTOR) : null
  if (!cell) return null
  return { row: Number(cell.dataset.row), col: Number(cell.dataset.col) }
}

/** Hücre içindeki etkileşimli öğeye (bağlantı, düğme, alan) yapılan tıklama seçimi başlatmaz. */
export function isInteractiveTarget(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    target.closest('a, button, input, select, textarea, label, [role="button"]') !== null
  )
}
